import { ChevronRightIcon, LogOutIcon, UserIcon } from 'lucide-react';
import { useFragment } from 'react-relay';
import { authButtonFragment } from './AuthButton.relay';
import type { AuthButtonPropsType } from './types';

const userEditUrl = '/auth/user-data-edit';

function AuthButton(props: AuthButtonPropsType) {
  const authLink = useFragment(authButtonFragment, props.authLink);

  if (!authLink.label || !authLink.url) {
    return null;
  }

  return (
    <div className="Button-auth Button-logout bg-accent items-center justify-between">
      {authLink.iconUrl ? (
        <a href={userEditUrl} className="Button-iam">
          {/* <Isvg src={authLink.iconUrl} /> */}
          <UserIcon className="text-gray-500" />
        </a>
      ) : null}
      <a href={authLink.url} className="Button-logout-label">
        <span className="Button-logout-label-small">
          <LogOutIcon className="w-5 h-5 font-normal" strokeWidth={1} />
        </span>
        <span className="Button-logout-label-large font-body text-[10px]">{authLink.label}</span>
      </a>
      <ChevronRightIcon className="mr-2 Button-logout-label-large" />
    </div>
  );
}

export { AuthButton };
